<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="page_i"></a><a id="page_ii"></a></p>
<p class="halftitle"><a id="page_iii"></a>Let’s Put the Future Behind Us</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle.vue?ee46097e